import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

import PetrolDeliveryGeoMapEditorWidget from '../../../../../widgets/logistics/petrol/PetrolDeliveryGeoMapEditorWidget/PetrolDeliveryGeoMapEditorWidget';
import PetrolDeliveryVehicleTableWidget from '../../../../../widgets/logistics/petrol/PetrolDeliveryVehicleTableWidget/PetrolDeliveryVehicleTableWidget';
import PetrolDeliveryMainTableWidget from '../../../../../widgets/logistics/petrol/PetrolDeliveryMainTableWidget/PetrolDeliveryMainTableWidget';

import Loading from '../../../../../shared/ui/Loading/Loading';

import DownlandExelButton from '../DownlandExelButton/DownlandExelButton';
import cancelEvent from '../../utils/cancelEvent';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import ButtonWrapper from './styles/ButtonWrapper';
import { useAppSelector } from '../../../../../app/store';
import reducerPath from '../../../../../app/reducerPath';
import { LogisticTasksEnum } from '../../../../../entities/logistic/logisticTasks/redux/logisticTasksPetrol.slice';
import mapNames from '../../../../../entities/map/constants';
import BackToTasksButton from '../../../../../features/logistics/BackToTasksButton/BackToTasksButton';

export default function MainPanelContent({
  isRunning,
  isStopping,
  showAwaitForOptimisationToast,
  logisticTask,
  reorderLogisticTask,
  waitForStatusFlag,
  onCLickSave,
  onCLickOptimize,
  onStopOptimizing,
  onCLickCreateRoutes,
}) {
  const [searchOrder, setSearchOrder] = React.useState('');

  const isFullScreen = useAppSelector((state) => state[`${reducerPath.fullScreenMap}`])[mapNames.logisticDelivery];
  const { rePlanDate } = useAppSelector((state) => state[`${reducerPath.logisticTasksPetrolResource}/counter`]);

  const isLogisticTaskPristine = useAppSelector((state) => {
    const store = state[`${reducerPath.logisticTasksPetrolResource}/counter`];

    return (
      store[LogisticTasksEnum.data] === store[LogisticTasksEnum.initialData] &&
      (rePlanDate
        ? rePlanDate === logisticTask?.data?.source.routeStartDate
        : !logisticTask?.data?.source.routeStartDate)
    );
  });

  return (
    <Container>
      <Wrapper
        isFullScreen={isFullScreen}
        isDisabled={isRunning || isStopping}
        onFocusCapture={isRunning || isStopping ? cancelEvent : null}
        onClickCapture={showAwaitForOptimisationToast}
      >
        <PetrolDeliveryGeoMapEditorWidget
          logisticTask={logisticTask}
          setSearchOrder={setSearchOrder}
          sx={{ pointerEvents: isRunning || isStopping ? 'none' : 'inherit' }}
        />
        {logisticTask?.isLoading ? (
          <Loading />
        ) : (
          <Box sx={{ pointerEvents: isRunning || isStopping ? 'none' : 'inherit' }}>
            <PetrolDeliveryVehicleTableWidget />
            <PetrolDeliveryMainTableWidget
              reorderLogisticTask={reorderLogisticTask}
              searchOrder={searchOrder}
              setSearchOrder={setSearchOrder}
            />
          </Box>
        )}
      </Wrapper>
      <ButtonWrapper>
        <Button
          variant="contained"
          onClick={() => onCLickSave()}
          disabled={!!logisticTask?.isLoading || isLogisticTaskPristine || waitForStatusFlag || isStopping}
        >
          Сохранить
        </Button>

        <DownlandExelButton disabled={!!logisticTask?.isLoading || isRunning || waitForStatusFlag || isStopping} />

        <Button
          variant="contained"
          onClick={isRunning ? onStopOptimizing : isStopping ? () => {} : onCLickOptimize}
          disabled={!!logisticTask?.isLoading || waitForStatusFlag || isStopping}
          startIcon={isRunning ? <CircularProgress size="20px" color="inherit" /> : null}
        >
          {isRunning ? 'Остановить оптимизацию' : isStopping ? 'Останавливается' : 'Оптимизировать'}
        </Button>
        <Button
          variant="contained"
          onClick={onCLickCreateRoutes}
          disabled={!!logisticTask?.isLoading || waitForStatusFlag || isStopping}
        >
          Создать маршруты
        </Button>
        <BackToTasksButton companyId={logisticTask?.data?.companyId} />
      </ButtonWrapper>
    </Container>
  );
}
MainPanelContent.propTypes = {
  isRunning: PropTypes.bool.isRequired,
  isStopping: PropTypes.bool.isRequired,
  showAwaitForOptimisationToast: PropTypes.func.isRequired,
  logisticTask: PropTypes.shape().isRequired,
  reorderLogisticTask: PropTypes.func.isRequired,
  waitForStatusFlag: PropTypes.bool.isRequired,
  onCLickSave: PropTypes.func.isRequired,
  onCLickOptimize: PropTypes.func.isRequired,
  onStopOptimizing: PropTypes.func.isRequired,
  onCLickCreateRoutes: PropTypes.func.isRequired,
};
